import {Component, OnInit, HostListener} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {RestringirMccProdutoService} from './restringir-mcc-produto.service';
import {NotificationsService} from 'angular2-notifications';
import {Location} from '@angular/common';
import {NgxSpinnerService} from 'ngx-spinner';
import {NbDialogService} from '@nebular/theme';
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'ngx-restringir-mcc-produto',
  templateUrl: './restringir-mcc-produto.component.html',
  styleUrls: ['./restringir-mcc-produto.component.scss'],
})
export class RestringirMccProdutoComponent implements OnInit {
  public spinnerLoad: boolean = false;
  public formProdutoMcc = null;
  public inpMcc = null;
  public listProdutos: any = [];
  public produto: any = null;
  public blocked: any = [];
  public unblocked: any = [];
  public resetedBlocked: any = [];
  public resetedUnblocked: any = [];
  public innerWidth: any;
  public checkedUnblockedList: any = [];
  public checkedBlockedList: any = [];

  constructor(
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private service: RestringirMccProdutoService,
    private location: Location,
    private spinnerService: NgxSpinnerService,
    private dialogService: NbDialogService,
    private router: Router
  ) {
    this.formProdutoMcc = this.formBuilder.group({
      inpMcc: [null],
      permitMcc: [null],
      produto: [null]
    });
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.spinnerService.show();
    this.service.buscaProdutos().subscribe((response) => {

      let arr = JSON.parse(JSON.stringify(response));
      arr.forEach(element => {
        if (element.produtoDescricao == 'VIAGEM') element.produtoDescricao = 'DESPESAS';
        if (element.produtoDescricao == 'ALIMENTACAO_BANDEIRADO') element.produtoDescricao = 'ALIMENTAÇÃO BANDEIRADO';
        if (element.produtoDescricao == 'REFEICAO_BANDEIRADO') element.produtoDescricao = 'REFEIÇÃO BANDEIRADO';
      });
      let orderedList = arr.sort(function (a, b) {
        if (a.produtoDescricao < b.produtoDescricao) {
          return -1;
        }
        if (a.produtoDescricao > b.produtoDescricao) {
          return 1;
        }
        return 0;
      });

      this.formProdutoMcc.controls['produto'].setValue(orderedList[orderedList.length - 1].produtoId);
      this.listProdutos = orderedList;

      this.fillBoxes();
    }, (error) => {
      this.spinnerService.hide();
      this.notifications.error(error.message);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
  }

  fillBoxes() {
    let params = new HttpParams();
    params = params.append('productId',
      this.formProdutoMcc.controls['produto'].value);

    this.service.buscaRestricoes(
      params,
      (response) => {
        this.blocked = response.blocked;
        this.unblocked = response.unblocked;
        let groupBlocked = this.groupByMcc(this.mapGroup(this.blocked));
        let groupUnblocked = this.groupByMcc(this.mapGroup(this.unblocked));
        this.resetedBlocked = this.resetFlatList(groupBlocked);
        this.resetedUnblocked = this.resetFlatList(groupUnblocked);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });
  }

  mapGroup(unmappedGrp) {
    let mappedGrp = [];
    unmappedGrp.forEach((element) => {
      mappedGrp.push({
        id: element.grupoId,
        grupo: {
          id: element.grupoId,
          nomeGrupo: element.nomeGrupo,
        },
        mcc: {
          id: element.mccId,
          descricao: element.descricao,
          mcc: element.mcc,
        },
      });
    });
    return mappedGrp;
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  buscaMcc(mcc) {
    let params = new HttpParams();
    params = params.append('productId',
      this.formProdutoMcc.controls['produto'].value);
    if (mcc != null && mcc.trim().length != 0) {
      params = params.append('descricao', mcc);
    }
    this.spinnerService.show();
    this.service.buscaRestricoes(
      params,
      (response) => {
        this.blocked = response.blocked;
        this.unblocked = response.unblocked;
        let groupBlocked = this.groupByMcc(this.mapGroup(this.blocked));
        let groupUnblocked = this.groupByMcc(this.mapGroup(this.unblocked));
        this.resetedBlocked = this.resetFlatList(groupBlocked);
        this.resetedUnblocked = this.resetFlatList(groupUnblocked);
        this.checkedUnblockedList.splice(0, this.checkedUnblockedList.length);
        this.checkedBlockedList.splice(0, this.checkedBlockedList.length);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });

  }

  resetFlatList(group) {
    let flatList = [];
    for (let list of group) {
      flatList.push({
        type: 'G',
        id: list.id,
        groupId: list.id,
        descricao: list.descricao,
      });
      for (let mccList of list.mcc) {
        flatList.push({
          type: 'M',
          id: mccList.mcc,
          descricao: mccList.descricao,
          groupId: list.id,
          groupDescricao: list.descricao,
          mccId: mccList.id,
        });
      }
    }
    return flatList;
  }

  save() {

    let temp = JSON.parse(JSON.stringify(this.resetedBlocked));
    let duplicatedRestricaoId = [];
    let uniqueRestricaoId = [];
    let restricaoIds = [];
    temp.forEach(element => {
      if (element.mccId != null) {
        duplicatedRestricaoId.push(element.mccId);
      }
    });

    uniqueRestricaoId = Array.from(new Set(duplicatedRestricaoId));

    uniqueRestricaoId.forEach(v => {
      restricaoIds.push({'restricaoId': v});
    });

    let obj = {
      'produtoId': this.formProdutoMcc.controls['produto'].value,
      'restricaoMcc': restricaoIds
    };
    this.spinnerService.show();

    this.service.salvaRestricoes(
      obj,
      (response) => {
        this.checkedUnblockedList.splice(0, this.checkedUnblockedList.length);
        this.notifications.success('Mccs restringidos com sucesso');
        this.buscaMcc(null);
        this.formProdutoMcc.controls['inpMcc'].setValue(null);
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });
  }

  groupByMcc(mccGroup) {
    return groupBy(mccGroup, (mccG) => mccG.grupo.id);
  }

  add() {
    let listRestrictionToAdd = [];
    let listGroupToAdd = [];
    let listRestrictionIdxToRemove = [];
    let listRestrictionMccsToRemove = [];

    for (let item of this.checkedUnblockedList) {
      for (let i of this.resetedUnblocked) {
        if (i.mccId == item.mccId) {
          listRestrictionToAdd.push(JSON.parse(JSON.stringify(i)));
          let filteredGroup = this.resetedUnblocked.filter(x => x.type == 'G' && x.groupId == i.groupId);
          let hasGroupAlready = listGroupToAdd.filter((x) => x.groupId == filteredGroup[0].groupId);
          if (hasGroupAlready.length == 0) {
            listGroupToAdd.push(JSON.parse(JSON.stringify(filteredGroup[0])));
          }
        }
      }
    }
    for (let aG of listGroupToAdd) {
      let filteredGroupBlocked = this.resetedBlocked.filter(x => x.type == 'G' && x.groupId == aG.groupId);
      if (filteredGroupBlocked.length == 0) {
        this.resetedBlocked.push(JSON.parse(JSON.stringify(aG)));
      }
    }

    for (let aR of listRestrictionToAdd) {
      let idxBlockedGroup = this.resetedBlocked.findIndex(x => x.type == 'G' && x.groupId == aR.groupId);
      let idxBlockedMcc = this.resetedBlocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      if (idxBlockedMcc == -1) this.resetedBlocked.splice(idxBlockedGroup + 1, 0, aR);
      aR.active = false;
      if (aR.checked) delete aR.checked;
      let idxUnblockedMcc = this.resetedUnblocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      listRestrictionIdxToRemove.push(idxUnblockedMcc);
      listRestrictionMccsToRemove.push(aR);
    }

    for (let aG of listGroupToAdd) {
      let filteredGroupUnblocked = this.resetedUnblocked.filter(x => x.groupId == aG.groupId);
      let filteredlistRestrictionMccsToRemove = listRestrictionMccsToRemove.filter(x => x.groupId == aG.groupId);
      if (filteredGroupUnblocked.length == filteredlistRestrictionMccsToRemove.length + 1) {
        let idxUnblockedGroup = this.resetedUnblocked.findIndex(x => x.type == 'G' && x.groupId == aG.groupId);
        listRestrictionIdxToRemove.push(idxUnblockedGroup);
      }
    }


    listRestrictionIdxToRemove = listRestrictionIdxToRemove.sort((a, b) => a - b).reverse();
    for (let idx of listRestrictionIdxToRemove) {
      this.resetedUnblocked.splice(idx, 1);
    }

    this.checkedUnblockedList.splice(0, this.checkedUnblockedList.length);
  }

  addAll() {
    let listRestrictionIdxToRemove = [];
    let listRestrictionMccsToRemove = [];
    let activeItem = this.resetedUnblocked.filter((item) => item.active);

    if (activeItem.length == 0) {
      activeItem.push({
        active: true,
        descricao: this.resetedUnblocked[0].descricao,
        groupId: this.resetedUnblocked[0].groupId,
        id: this.resetedUnblocked[0].id,
        type: this.resetedUnblocked[0].type,
      });
    }

    let filteredRestrictions = JSON.parse(JSON.stringify(this.resetedUnblocked.filter(
      (item) => item.groupId == activeItem[0].groupId && item.type == 'M'
    )));

    let activeGroup = [];
    let activeRestrictions = [];
    filteredRestrictions.forEach(element => {
      this.resetedUnblocked.forEach(element2 => {
        if (element2.mccId == element.mccId) {
          activeRestrictions.push(JSON.parse(JSON.stringify(element2)));
          let filteredGroup = this.resetedUnblocked.filter(x => x.type == 'G' && x.groupId == element2.groupId);
          let hasGroupAlready = activeGroup.filter((x) => x.groupId == filteredGroup[0].groupId);
          if (hasGroupAlready.length == 0) {
            activeGroup.push(JSON.parse(JSON.stringify(filteredGroup[0])));
          }
        }
      });
    });

    activeRestrictions.forEach(element => {
      element.active = false;
    });

    activeGroup.forEach(element => {
      element.active = false;
    });

    for (let aG of activeGroup) {
      let filteredGroupBlocked = this.resetedBlocked.filter(x => x.type == 'G' && x.groupId == aG.groupId);
      if (filteredGroupBlocked.length == 0) {
        this.resetedBlocked.push(JSON.parse(JSON.stringify(aG)));
      }
    }

    for (let aR of activeRestrictions) {
      let idxBlockedGroup = this.resetedBlocked.findIndex(x => x.type == 'G' && x.groupId == aR.groupId);
      let idxBlockedMcc = this.resetedBlocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      if (idxBlockedMcc == -1) this.resetedBlocked.splice(idxBlockedGroup + 1, 0, aR);
      let idxUnblockedMcc = this.resetedUnblocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      listRestrictionIdxToRemove.push(idxUnblockedMcc);
      listRestrictionMccsToRemove.push(aR);
    }

    for (let aG of activeGroup) {
      let filteredGroupUnblocked = this.resetedUnblocked.filter(x => x.groupId == aG.groupId);
      let filteredlistRestrictionMccsToRemove = listRestrictionMccsToRemove.filter(x => x.groupId == aG.groupId);
      if (filteredGroupUnblocked.length == filteredlistRestrictionMccsToRemove.length + 1) {
        let idxUnblockedGroup = this.resetedUnblocked.findIndex(x => x.type == 'G' && x.groupId == aG.groupId);
        listRestrictionIdxToRemove.push(idxUnblockedGroup);
      }
    }

    listRestrictionIdxToRemove = listRestrictionIdxToRemove.sort((a, b) => a - b).reverse();
    for (let idx of listRestrictionIdxToRemove) {
      this.resetedUnblocked.splice(idx, 1);
    }

    this.checkedUnblockedList.splice(0, this.checkedUnblockedList.length);
  }

  remove() {

    let listRestrictionToRemove = [];
    let listGroupToRemove = [];
    let listRestrictionIdxToRemove = [];
    let listRestrictionMccsToRemove = [];

    for (let item of this.checkedBlockedList) {
      for (let i of this.resetedBlocked) {
        if (i.mccId == item.mccId) {
          listRestrictionToRemove.push(JSON.parse(JSON.stringify(i)));
          let filteredGroup = this.resetedBlocked.filter(x => x.type == 'G' && x.groupId == i.groupId);
          let hasGroupAlready = listGroupToRemove.filter((x) => x.groupId == filteredGroup[0].groupId);
          if (hasGroupAlready.length == 0) {
            listGroupToRemove.push(JSON.parse(JSON.stringify(filteredGroup[0])));
          }
        }
      }
    }
    for (let aG of listGroupToRemove) {
      let filteredGroupBlocked = this.resetedUnblocked.filter(x => x.type == 'G' && x.groupId == aG.groupId);
      if (filteredGroupBlocked.length == 0) {
        this.resetedUnblocked.push(JSON.parse(JSON.stringify(aG)));
      }
    }

    for (let aR of listRestrictionToRemove) {
      let idxUnBlockedGroup = this.resetedUnblocked.findIndex(x => x.type == 'G' && x.groupId == aR.groupId);
      let idxUnBlockedMcc = this.resetedUnblocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      if (idxUnBlockedMcc == -1) this.resetedUnblocked.splice(idxUnBlockedGroup + 1, 0, aR);
      aR.active = false;
      if (aR.checked) delete aR.checked;
      let idxBlockedMcc = this.resetedBlocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      listRestrictionIdxToRemove.push(idxBlockedMcc);
      listRestrictionMccsToRemove.push(aR);
    }

    for (let aG of listGroupToRemove) {
      let filteredGroupUnblocked = this.resetedBlocked.filter(x => x.groupId == aG.groupId);
      let filteredlistRestrictionMccsToRemove = listRestrictionMccsToRemove.filter(x => x.groupId == aG.groupId);
      if (filteredGroupUnblocked.length == filteredlistRestrictionMccsToRemove.length + 1) {
        let idxUnblockedGroup = this.resetedBlocked.findIndex(x => x.type == 'G' && x.groupId == aG.groupId);
        listRestrictionIdxToRemove.push(idxUnblockedGroup);
      }
    }


    listRestrictionIdxToRemove = listRestrictionIdxToRemove.sort((a, b) => a - b).reverse();
    for (let idx of listRestrictionIdxToRemove) {
      this.resetedBlocked.splice(idx, 1);
    }

    this.checkedBlockedList.splice(0, this.checkedBlockedList.length);
  }

  removeAll() {

    let listRestrictionIdxToRemove = [];
    let listRestrictionMccsToRemove = [];
    let activeItem = this.resetedBlocked.filter((item) => item.active);

    if (activeItem.length == 0) {
      activeItem.push({
        active: true,
        descricao: this.resetedBlocked[0].descricao,
        groupId: this.resetedBlocked[0].groupId,
        id: this.resetedBlocked[0].id,
        type: this.resetedBlocked[0].type,
      });
    }

    let filteredRestrictions = JSON.parse(JSON.stringify(this.resetedBlocked.filter(
      (item) => item.groupId == activeItem[0].groupId && item.type == 'M'
    )));

    let activeGroup = [];
    let activeRestrictions = [];
    filteredRestrictions.forEach(element => {
      this.resetedBlocked.forEach(element2 => {
        if (element2.mccId == element.mccId) {
          activeRestrictions.push(JSON.parse(JSON.stringify(element2)));
          let filteredGroup = this.resetedBlocked.filter(x => x.type == 'G' && x.groupId == element2.groupId);
          let hasGroupAlready = activeGroup.filter((x) => x.groupId == filteredGroup[0].groupId);
          if (hasGroupAlready.length == 0) {
            activeGroup.push(JSON.parse(JSON.stringify(filteredGroup[0])));
          }
        }
      });
    });

    activeRestrictions.forEach(element => {
      element.active = false;
    });

    activeGroup.forEach(element => {
      element.active = false;
    });

    for (let aG of activeGroup) {
      let filteredGroupUnBlocked = this.resetedUnblocked.filter(x => x.type == 'G' && x.groupId == aG.groupId);
      if (filteredGroupUnBlocked.length == 0) {
        this.resetedUnblocked.push(JSON.parse(JSON.stringify(aG)));
      }
    }

    for (let aR of activeRestrictions) {
      let idxUnBlockedGroup = this.resetedUnblocked.findIndex(x => x.type == 'G' && x.groupId == aR.groupId);
      let idxUnBlockedMcc = this.resetedUnblocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      if (idxUnBlockedMcc == -1) this.resetedUnblocked.splice(idxUnBlockedGroup + 1, 0, aR);

      let idxBlockedMcc = this.resetedBlocked.findIndex(x => x.type == 'M' && x.groupId == aR.groupId && x.mccId == aR.mccId);
      listRestrictionIdxToRemove.push(idxBlockedMcc);
      listRestrictionMccsToRemove.push(aR);
    }

    for (let aG of activeGroup) {
      let filteredGroupBlocked = this.resetedBlocked.filter(x => x.groupId == aG.groupId);
      let filteredlistRestrictionMccsToRemove = listRestrictionMccsToRemove.filter(x => x.groupId == aG.groupId);
      if (filteredGroupBlocked.length == filteredlistRestrictionMccsToRemove.length + 1) {
        let idxUnblockedGroup = this.resetedBlocked.findIndex(x => x.type == 'G' && x.groupId == aG.groupId);
        listRestrictionIdxToRemove.push(idxUnblockedGroup);
      }
    }
    listRestrictionIdxToRemove = listRestrictionIdxToRemove.sort((a, b) => a - b).reverse();
    for (let idx of listRestrictionIdxToRemove) {
      this.resetedBlocked.splice(idx, 1);
    }

    this.checkedBlockedList.splice(0, this.checkedUnblockedList.length);
  }

  selectedUnblocked(itemSelected) {
    for (let item of this.resetedUnblocked) {
      item.active = false;
    }
    itemSelected.active = true;
  }

  selectedBlocked(itemSelected) {
    for (let item of this.resetedBlocked) {
      if (item.active) {
        item.active = false;
      }
    }
    itemSelected.active = true;
  }

  changeCheckboxBlocked(event, item) {

    if (event.target.checked) {
      let filteredCheckList = this.checkedBlockedList.filter(
        (i) => item.id == i.id
      );
      for (let i = 0; i < this.checkedBlockedList.length; i++) {
        if (filteredCheckList && this.checkedBlockedList[i].id == item.id) {
          this.checkedBlockedList[i].checked++;
        }
      }
      item.checked = 1;
      if (filteredCheckList.length == 0) this.checkedBlockedList.push(item);
    } else {
      let idx = this.checkedBlockedList.findIndex((x) => x.id === item.id);
      if (this.checkedBlockedList[idx].checked > 1)
        this.checkedBlockedList[idx].checked--;
      else this.checkedBlockedList.splice(idx, 1);
    }
  }

  changeCheckboxUnblocked(event, item) {
    if (event.target.checked) {
      let filteredCheckList = this.checkedUnblockedList.filter(
        (i) => item.id == i.id
      );
      for (let i = 0; i < this.checkedUnblockedList.length; i++) {
        if (filteredCheckList && this.checkedUnblockedList[i].id == item.id) {
          this.checkedUnblockedList[i].checked++;
        }
      }
      item.checked = 1;
      if (filteredCheckList.length == 0) this.checkedUnblockedList.push(item);
    } else {
      let idx = this.checkedUnblockedList.findIndex((x) => x.id === item.id);
      if (this.checkedUnblockedList[idx].checked > 1)
        this.checkedUnblockedList[idx].checked--;
      else this.checkedUnblockedList.splice(idx, 1);
    }
  }
}

function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      let mergArr = item.grupo;
      mergArr.descricao = item.grupo.nomeGrupo;
      mergArr.mcc = [item.mcc];
      map.set(key, [mergArr]);
    } else {
      collection[0].mcc.push(item.mcc);
      map.set(key, collection);
    }
  });
  return Array.from(map.values()).map(function (i) {
    return i[0];
  });
}
